export default {
  "TopAgreements.Title": "パーソナルデータの取扱いに関する同意再設定のお願い",
  "TopAgreements.TextTop":
    "パーソナルデータの取扱いに関してお客さまから頂いた同意設定が正常に登録できておりません\nお手数をおかけしますが、再度、同意事項を確認ください",
  "TopAgreements.LinkText": "パーソナルデータの取扱いに関する同意事項(必読)",
  "TopAgreements.LinkUrl":
    "https://datadashboard-biz-service.front.smt.docomo.ne.jp/acc9a0f",
  "TopAgreements.TextCheckbox":
    "パーソナルデータの取扱いに関する同意事項に同意する",
  "TopAgreements.TextMid1":
    "必ず同意事項をご確認いただき、同意の上「登録する」を押下してください",
  "TopAgreements.TextMid2":
    "同意いただいた設定を変更する場合、当該パーソナルデータダッシュボード上の「第三者提供の管理」画面、「位置情報利用の管理」画面、「お知らせ配信の設定」の「キャンペーン・特典などのお知らせ」画面より設定を変更してください",
  "TopAgreements.OkButton": "登録する",
}
